import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/MasterData/ProjectLocation/add'
import constant from '../../../constant'
import { toast } from 'react-toastify'
import { v3_add_project_location } from '../../../actions/v3/masterData'
const Add = (props) => {

    const onSubmit = (model) => {
        v3_add_project_location(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listProjectLocationMasterData.url)
            }
            else {
                toast.error(res.error)

            }
        })
    }
    return (
        <React.Fragment>
            <Layout
                title={'Master Data'}
            >
                <Form
                    title={'Add Project Location'}
                    onSubmit={onSubmit}
                    buttonName={'Create Project Location'}
                />
            </Layout>
        </React.Fragment>
    )
}

export default Add